export default __webpack_public_path__ + "static/media/python_icon.11ac3b65.png";